import { useBundleCatalog, useSamplesCatalog } from '@landr/pricing';
import {
    UseCatalogSaleProps,
    useGetDiscountedPlan,
} from 'hooks/useGetDiscountedPlan/useGetDiscountedPlan';

export const usePricingCatalogs = (props?: UseCatalogSaleProps) => {
    const { data: studioCatalog } = useBundleCatalog();
    const { data: samplesCatalog } = useSamplesCatalog();
    const { catalogSale, getDiscountedPlan } = useGetDiscountedPlan(props);

    return { studioCatalog, samplesCatalog, catalogSale, getDiscountedPlan };
};
